import { PORTAL_TYPE } from '../types/app.types';
import getImagePath from '../network/services/get-images/get-images.service';

export type portalsDataType = {
  id: PORTAL_TYPE;
  logo: string;
  rootLink: string;
  redirection: {
    description: string;
    link: string;
  };
};

const portalsData: { [key in PORTAL_TYPE]: portalsDataType } = {
  [PORTAL_TYPE.ERDE]: {
    id: PORTAL_TYPE.ERDE,
    logo: getImagePath('button-edenred.png'),
    rootLink: `${process.env.REACT_APP_LINK_ERDE}`,
    redirection: {
      description: 'redirectionPage.redirectDescription.ERDE',
      link: 'edenred.de/akzeptanzpartner'
    }
  },
  [PORTAL_TYPE.ER1]: {
    id: PORTAL_TYPE.ER1,
    logo: getImagePath('button-edenred-one.png'),
    rootLink: `${process.env.REACT_APP_LINK_ER1}`,
    redirection: {
      description: 'redirectionPage.redirectDescription.ER1',
      link: 'Edenred-One.de'
    }
  },
  [PORTAL_TYPE.FMER]: {
    id: PORTAL_TYPE.FMER,
    logo: getImagePath('button-umer.png'),
    rootLink: `${process.env.REACT_APP_LINK_FMER}`,
    redirection: {
      description: 'redirectionPage.redirectDescription.FMER',
      link: 'Firmenkunden.Mein-Edenred.de'
    }
  },
  [PORTAL_TYPE.UMER]: {
    id: PORTAL_TYPE.UMER,
    logo: getImagePath('button-umer.png'),
    rootLink: `${process.env.REACT_APP_LINK_UMER}`,
    redirection: {
      description: 'redirectionPage.redirectDescription.UMER',
      link: 'Mein-Edenred.de'
    }
  },
  [PORTAL_TYPE.EBUSER]: {
    id: PORTAL_TYPE.EBUSER,
    logo: getImagePath('button-edenred-user.png'),
    rootLink: `${process.env.REACT_APP_LINK_EBUSER}`,
    redirection: {
      description: 'redirectionPage.redirectDescription.EBUSER',
      link: 'nutzer.edenred.de'
    }
  },
  [PORTAL_TYPE.EBCLIENT]: {
    id: PORTAL_TYPE.EBCLIENT,
    logo: getImagePath('button-edenred-client.png'),
    rootLink: `${process.env.REACT_APP_LINK_EBCLIENT}`,
    redirection: {
      description: 'redirectionPage.redirectDescription.EBCLIENT',
      link: ''
    }
  }
};

const usePortalsData = () => {
  return (portalType: PORTAL_TYPE): portalsDataType => portalsData[portalType];
};
export default usePortalsData;
